import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AboutSection.module.scss';

const AboutSection = () => {
    const navigate = useNavigate();

    return (
        <section className={styles.about} aria-label="About">
            <div className={styles.inner}>
                <p className={styles.body}>
                    Prepal is not a tech savvy byproduct, we are tutors that have been in the
                    trenches tutoring students for years. We built Prepal because we saw
                    firsthand what works:
                </p>
                <p className={styles.boldLine}>
                    <span className={styles.hoverPhrase}>Personalized Practice</span>,{' '}
                    <span className={styles.hoverPhrase}>Instant Feedback</span>, and{' '}
                    <span className={styles.hoverPhrase}>Concept Mastery</span>.
                </p>
                <button
                    className={styles.ctaBtn}
                    onClick={() => navigate('/about-us')}
                >
                    About Us
                </button>
            </div>
        </section>
    );
};

export default AboutSection;
